<main>
  <ng-container *ngIf="accessibilityInfoReady">
    <section>

      <!-- Título -->
      <div class="container-fluid ptb-42">
        <div class="row">
          <div class="col-auto">
            <div class="titles-bdr-r">
              <h1 class="color-primary fs-325remTitles">{{accessibilityInfo.Titulo_Pagina}}</h1>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class="container pb-120 gx-5 gx-lg-0 tab-style4">

        <!-- Descrição -->
        <div class="row justify-content-center mb-4">
          <div class="col-lg-10 col-12">
            <h3 class="color-primary fw-500">{{accessibilityInfo.Titulo_Seccao}}</h3>
            <h5 class="mb-3">{{accessibilityInfo.Subtitulo_Seccao}}</h5>
            <p [innerHTML]="accessibilityInfo.Texto_Seccao"></p>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-12 col-lg-3 col-xxl-3 pe-lg-0 px-2 mt-5">

            <!-- start tab navigation reservations-->
            <ul class="nav nav-tabs sticky-lg-top">
              <li class="nav-item color-black">
                <a class="nav-link" data-bs-toggle="tab" href="#tab-reservas-1" [ngClass]="{active: true}">{{accessibilityInfo.Tab1_Titulo}}</a>
              </li>
              <li class="nav-item color-black">
                <a class="nav-link" data-bs-toggle="tab" href="#tab-reservas-2">{{accessibilityInfo.Tab2_Titulo}}</a>
              </li>
              <li class="nav-item color-black">
                <a class="nav-link" data-bs-toggle="tab" href="#tab-reservas-3">{{accessibilityInfo.Tab3_Titulo}}</a>
              </li>
            </ul>
            <!-- end tab navigation reservations -->
          </div>

          <div class="col-12 col-lg-9 col-xxl-7 ps-lg-0 px-2">
            <div class="tab-content">

              <!-- Content Condições Acesso -->
              <div class="tab-pane p-top-tabs-content" id="tab-reservas-1" [ngClass]="{active: true}">
                <div class="row align-items-center justify-content-center">
                  <div class="col-12">
                    <p [innerHTML]="accessibilityInfo.Tab1_Texto"></p>
                  </div>
                </div>
              </div>

              <!-- Content Aderir -->
              <div class="tab-pane p-top-tabs-content" id="tab-reservas-2">
                <div class="row align-items-center justify-content-center">
                  <div *ngIf="formAderir" class="col-12">
                    <div *ngIf="!submittedAderir" class="col-12">
                      <p [innerHTML]="accessibilityInfo.Tab2_Texto"></p>
                    </div>
                    <form class="reserve-form" [formGroup]="formAderir" *ngIf="showFormAderir" (ngSubmit)="onSubmitAderir()">
                      <fieldset>
                        <div class="row">
                          <!-- First Name input -->
                          <div class="form-group col-sm-6 col-12 mb-3">
                            <label aria-label="Nome" class="mb-1">{{'formLabels.nome' | translate}}<span class="text-danger ms-1 fw-800">*</span></label>
                            <input type="text" class="form-control"placeholder="{{'formPlaceholders.nome' | translate}}"
                              formControlName="firstName" [ngClass]="{ 'is-invalid': submittedAderir && fA['firstName'].errors }">
                            <div *ngIf="submittedAderir && fA['firstName'].errors" class="invalid-feedback">{{'formErrorFeedback.preenchimentoObrigatorio' | translate}}</div>
                          </div>

                          <!-- Second Name input -->
                          <div class="form-group col-sm-6 col-12 mb-3">
                            <label aria-label="Apelido" class="mb-1">{{'formLabels.apelido' | translate}}<span class="text-danger ms-1 fw-800">*</span></label>
                            <input type="text" class="form-control" placeholder="{{'formPlaceholders.apelido' | translate}}"
                              formControlName="lastName" [ngClass]="{ 'is-invalid': submittedAderir && fA['lastName'].errors }">
                            <div *ngIf="submittedAderir && fA['lastName'].errors" class="invalid-feedback">{{'formErrorFeedback.preenchimentoObrigatorio' | translate}}</div>
                          </div>

                          <!-- NIF input -->
                          <div class="form-group col-sm-6 col-12 mb-3">
                            <label aria-label="NIF" class="mb-1">{{'formLabels.nif' | translate}}<span class="text-danger ms-1 fw-800">*</span></label>
                            <input mask="000 000 000" type="text" inputmode="numeric" class="form-control"
                              placeholder="{{'formPlaceholders.nif' | translate}}" formControlName="nif" [ngClass]="{ 'is-invalid': submittedAderir && fA['nif'].errors }">
                            <div *ngIf="submittedAderir && fA['nif'].errors" class="invalid-feedback">
                              <div *ngIf="fA['nif'].errors['required']">{{'formErrorFeedback.preenchimentoObrigatorio' | translate}}</div>
                              <div *ngIf="fA['nif'].errors['pattern'] || fA['nif'].errors['invalidNif']">{{'formErrorFeedback.nifValido' | translate}}</div>
                            </div>
                          </div>

                          <!-- Number input -->
                          <div class="form-group col-sm-6 col-12 mb-3">
                            <label aria-label="Contacto" class="mb-1">{{'formLabels.contacto' | translate}}<span class="text-danger ms-1 fw-800">*</span></label>
                            <ngx-intl-tel-input
                              [cssClass]="'form-control'"
                              [preferredCountries]="preferredCountries"
                              [enableAutoCountrySelect]="true"
                              [enablePlaceholder]="true"
                              [customPlaceholder]="'formPlaceholders.contacto' | translate"
                              [searchCountryFlag]="true"
                              [searchCountryField]="[SearchCountryField.Iso2,SearchCountryField.Name]"
                              [selectFirstCountry]="false"
                              [selectedCountryISO]="CountryISO.Portugal"
                              [maxLength]="15"
                              [phoneValidation]="true"
                              formControlName="phone"
                              [numberFormat]="PhoneNumberFormat.National"
                              [ngClass]="{ 'is-invalid': submittedAderir && fA['phone'].errors }">
                            </ngx-intl-tel-input>
                            <div *ngIf="submittedAderir && fA['phone'].errors" class="invalid-feedback">{{'formErrorFeedback.telefoneValido' | translate}}</div>
                          </div>

                          <!-- Email input -->
                          <div class="form-group col-12 mb-3">
                            <label aria-label="Email" class="mb-1">{{'formLabels.email' | translate}}<span class="text-danger ms-1 fw-800">*</span></label>
                            <input type="email" class="form-control" placeholder="{{'formPlaceholders.email' | translate}}"
                              formControlName="email" [ngClass]="{ 'is-invalid': submittedAderir && fA['email'].errors }">
                            <div *ngIf="submittedAderir && fA['email'].errors" class="invalid-feedback">
                              <div *ngIf="fA['email'].errors['required']">{{'formErrorFeedback.preenchimentoObrigatorio' | translate}}</div>
                              <div *ngIf="fA['email'].errors['email']">{{'formErrorFeedback.emailValido' | translate}}</div>
                            </div>
                          </div>

                          <!-- Efeitos de Mobilidade Radiobutton -->
                          <div class="form-group col-12 mb-3 d-flex flex-column">
                            <label aria-label="Efeitos de Mobilidade" class="mb-1">
                              {{'formPlaceholders.utilizaCadeiraRodas' | translate}}<span class="text-danger ms-1 fw-800">*</span>
                            </label>
                            <div class="d-inline">
                              <div class="form-check form-check-inline">
                                <input type="radio" class="form-check-input" id="radioYes" formControlName="necessitaCadeiraRodas" [value]="true" [ngClass]="{ 'is-invalid': submittedAderir && fA['necessitaCadeiraRodas'].errors }">
                                <label aria-label="Sim" class="mx-2 form-check-label fw-500" for="radioYes">{{'formPlaceholders.sim' | translate}}</label>
                              </div>
                              <div class="form-check form-check-inline">
                                <input type="radio" class="form-check-input" id="radioNo" formControlName="necessitaCadeiraRodas" [value]="false" [ngClass]="{ 'is-invalid': submittedAderir && fA['necessitaCadeiraRodas'].errors }">
                                <label aria-label="Não" class="mx-2 form-check-label fw-500" for="radioNo">{{'formPlaceholders.nao' | translate}}</label>
                              </div>
                              <div *ngIf="submittedAderir && fA['necessitaCadeiraRodas'].errors" class="invalid-feedback d-block"  [ngClass]="{ 'is-invalid': submittedAderir && fA['necessitaCadeiraRodas'].errors }">
                                <div *ngIf="fA['necessitaCadeiraRodas'].errors['required']">{{'formErrorFeedback.preenchimentoObrigatorio' | translate}}</div>
                              </div>
                            </div>
                            <div *ngIf="erroCadeiraRodas" class="alert alert-warning mt-3">
                              <p class="fs-14px m-0">{{'formPlaceholders.erroCadeiraRodas' | translate}}</p>
                            </div>
                          </div>

                          <!-- File Upload Text -->
                          <div class="form-group col-12 mb-3">
                            <p class="fs-14px">{{'formPlaceholders.textoAnexosMultiusos' | translate}}</p>
                            <input class="form-control" id="files" type="file" title="Anexar Ficheiros" formControlName="files" multiple (change)="onFileChangeReservesUnique($event)" accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx" [ngClass]="{ 'is-invalid': submittedAderir && fA['files'].errors }"/>
                            <div *ngIf="submittedAderir && fA['files'].errors" class="invalid-feedback">
                              <div>{{'formErrorFeedback.preenchimentoObrigatorio' | translate}}</div>
                            </div>
                          </div>
                          <div *ngIf="fileError" class="form-group col-12 mb-3"><span [innerHTML]="fileError"></span></div>

                          <!-- CheckBox Accept Terms Accessibility -->
                          <div class="form-group col-12 my-2">
                            <div class="form-check">
                              <input type="checkbox" id="acceptTermsAccessibility" formControlName="acceptTermsAccessibility" class="form-check-input" [ngClass]="{ 'is-invalid': submittedAderir && fA['acceptTermsAccessibility'].errors }"/>
                              <label aria-label="Checkbox Termos e Condições Acessibilidade" for="acceptTermsAccessibility" class="form-check-label fs-12px">{{'formPlaceholders.termosAdesaoReservaText1.1' | translate}} <a [routerLink]="'/direitos-deveres'" target="_blank">{{'formPlaceholders.termosAdesaoReservaText1.2' | translate}}</a>{{'formPlaceholders.termosAdesaoReservaText1.3' | translate}}</label>
                              <div *ngIf="submittedAderir && fA['acceptTermsAccessibility'].errors"
                                class="invalid-feedback">{{'formErrorFeedback.termosCadeiraRodasObrigatorio' | translate}}</div>
                            </div>
                          </div>

                          <!-- CheckBox Accept Terms General -->
                          <div class="form-group col-12 my-2">
                            <div class="form-check">
                              <input type="checkbox" id="acceptTerms" formControlName="acceptTerms"
                                class="form-check-input" [ngClass]="{ 'is-invalid': submittedAderir && fA['acceptTerms'].errors }"/>
                              <label aria-label="Checkbox Termos e Condições" for="acceptTerms" class="form-check-label fs-12px">
                                {{'formPlaceholders.termosAdesaoReservaText2.1' | translate}}<a [routerLink]="'/politica-privacidade'" target="_blank" class="fw-700">
                                  {{'navLinks.politicaPrivacidade' | translate}}</a>{{'formPlaceholders.termosAdesaoReservaText2.2' | translate}}
                              </label>
                              <div *ngIf="submittedAderir && fA['acceptTerms'].errors" class="invalid-feedback">{{'formErrorFeedback.termosObrigatorio' | translate}}</div>
                            </div>
                          </div>

                          <!-- Submit button -->
                          <div class="justify-content-end col-12 d-flex form-group my-3">
                            <button *ngIf="!inProgressAderir" type="button" class="btn btn-outline-secondary me-4" title="Limpar Formulário" (click)="onResetAderir()">
                              <p class="m-0 fw-600">{{'buttons.limpar' | translate}}<i class="uil uil-backspace fs-20px ms-2"></i></p></button>
                            <button *ngIf="!inProgressAderir"  type="submit" [disabled]="erroCadeiraRodas" class="btn btn-primary col-lg-2 col-6" title="Enviar Formulário">
                              <p class="m-0 fw-600">{{'buttons.enviar' | translate}}<i class="uil uil-arrow-up-right fs-20px ms-2 color-white"></i></p></button>
                          </div>
                        </div>
                      </fieldset>
                    </form>

                    <!-- Loading Message -->
                    <div *ngIf="inProgressAderir" class="alert alert-warning">
                      <p class="m-0">{{ 'formFeedback.submittingMember' | translate }}</p>
                      <p class="m-0">{{ 'formFeedback.pleaseWait' | translate }}</p>
                    </div>
                    <!-- Success Info -->
                    <div *ngIf="successAderir" class="alert alert-success">
                      <p class="m-0">{{ 'formFeedback.successMemberInfoLine1' | translate }}</p>
                      <p class="m-0">{{ 'formFeedback.successMemberInfoLine2' | translate }}</p>
                      <p class="m-0 fw-800">{{ 'formFeedback.successMemberInfoLine3' | translate }}</p>
                    </div>

                    <div *ngIf="successAderir && errorOnFiles" class="alert alert-warning">
                      <p class="m-0">{{ 'formFeedback.errorMemberFileLine1' | translate }}</p>
                      <p class="m-0">{{ 'formFeedback.errorMemberFileLine2' | translate }}</p>
                      <p class="m-0 fw-800">{{ 'formFeedback.errorMemberFileLine3' | translate }}</p>
                    </div>

                    <div *ngIf="errorAderir" class="alert alert-danger">
                      <p class="m-0">{{ 'formFeedback.errorMemberLine1' | translate }}</p>
                      <p class="m-0 fw-800">{{ 'formFeedback.errorMemberLine2' | translate }}</p>
                    </div>

                  </div>
                </div>
              </div>

              <!-- Content Reservar -->
              <div class="tab-pane p-top-tabs-content" id="tab-reservas-3">
                <div class="row align-items-center justify-content-center">
                  <!-- ------- Form Envio Código Reserva // Validação ------- -->
                  <div class="col-12">
                    <div *ngIf="!submittedValidar" class="col-12">
                      <p [innerHTML]="accessibilityInfo.Tab3_Texto"></p>
                    </div>
                    <form class="reserve-form" [formGroup]="formValidar" *ngIf="showFormValidar" (ngSubmit)="onSubmitValidar()">
                      <fieldset [disabled]="showFormReservar"> <!-- Put 'disable' if form is submited -->
                        <div class="row">

                          <!-- NIF input -->
                          <div class="form-group col-sm-6 col-12 mb-3">
                            <label aria-label="NIF" class="mb-1">{{'formLabels.nif' | translate}}<span class="text-danger ms-1 fw-800">*</span></label>
                            <input mask="000 000 000" type="text" inputmode="numeric" class="form-control"
                              placeholder="{{'formPlaceholders.nif' | translate}}" formControlName="vat" [ngClass]="{ 'is-invalid': submittedValidar && fRV['vat'].errors }">
                            <div *ngIf="submittedValidar && fRV['vat'].errors" class="invalid-feedback">
                              <div *ngIf="fRV['vat'].errors['required']">{{'formErrorFeedback.preenchimentoObrigatorio' | translate}}</div>
                              <div *ngIf="fRV['vat'].errors['pattern'] || fRV['vat'].errors['invalidNif']">{{'formErrorFeedback.nifValido' | translate}}</div>
                            </div>
                          </div>

                          <!-- Code input -->
                          <div class="form-group col-sm-6 col-12 mb-3">
                            <label aria-label="Código de Adesão" class="mb-1">{{'formLabels.codigoAdesao' | translate}}<span class="text-danger ms-1 fw-800">*</span></label>
                            <input type="text" maxlength="6" class="form-control" placeholder="{{'formLabels.codigoAdesao' | translate}}"
                              formControlName="code" [ngClass]="{ 'is-invalid': submittedValidar && fRV['code'].errors }">
                            <div *ngIf="submittedValidar && fRV['code'].errors" class="invalid-feedback">
                              {{'formErrorFeedback.preenchimentoObrigatorio' | translate}}
                            </div>
                          </div>

                          <!-- Submit button -->
                          <div class="justify-content-end col-12 d-flex form-group my-3">
                            <button type="button" class="btn btn-outline-secondary me-4" title="Limpar Formulário" (click)="onResetValidar()">
                              <p class="m-0 fw-600">{{'buttons.limpar' | translate}}<i class="uil uil-backspace fs-20px ms-2"></i></p>
                            </button>
                            <button type="submit" class="btn btn-primary col-lg-2 col-6" title="Validar Formulário">
                              <p class="m-0 fw-600">{{'buttons.validar' | translate}}<i class="uil uil-check fs-20px ms-2 color-white"></i></p>
                            </button>
                          </div>
                        </div>
                      </fieldset>
                    </form>

                    <!-- Loading Message -->
                    <div *ngIf="inProgressValidar" class="alert alert-warning">
                      <p class="m-0">{{ 'formFeedback.validatingMember' | translate }}</p>
                      <p class="m-0">{{ 'formFeedback.pleaseWait' | translate }}</p>
                    </div>
                    <!-- Error Info -->
                    <div *ngIf="errorValidar" class="alert alert-danger">
                      <p class="m-0 fw-800">{{ 'formFeedback.errorValidatingMember' | translate }}</p>
                    </div>
                  </div>

                  <!-- ------- Form Preenchimento detalhes de Reserva ------- -->
                  <div class="col-12">

                    <form class="reserve-form" [formGroup]="formReservar" *ngIf="showFormReservar" (ngSubmit)="onSubmitReservar()">
                      <fieldset>
                        <div class="row">

                          <!-- First Name input -->
                          <div class="form-group col-sm-6 col-12 mb-3">
                            <label aria-label="Nome" class="mb-1">{{'formLabels.nome' | translate}}</label>
                            <input type="text" class="form-control" formControlName="firstName" placeholder="{{ validatedMember['first_name'] }}">
                          </div>
                          <!-- Last Name input -->
                          <div class="form-group col-sm-6 col-12 mb-3">
                            <label aria-label="Apelido" class="mb-1">{{'formLabels.apelido' | translate}}</label>
                            <input type="text" class="form-control" formControlName="lastName" placeholder="{{ validatedMember['last_name'] }}">
                          </div>
                          <!-- NIF input -->
                          <div class="form-group col-sm-6 col-12 mb-3">
                            <label aria-label="NIF" class="mb-1">{{'formLabels.nif' | translate}}</label>
                            <input mask="000 000 000" type="number" class="form-control" formControlName="nif" placeholder="{{ validatedMember['vat'] }}">
                          </div>
                          <!-- Email input -->
                          <div class="form-group col-sm-6 col-12 mb-3">
                            <label aria-label="Email" class="mb-1">{{'formLabels.email' | translate}}</label>
                            <input type="text" class="form-control" formControlName="email" placeholder="{{ validatedMember['email'] }}">
                          </div>
                          <!-- Phone input -->
                          <div class="form-group col-sm-6 col-12 mb-3">
                            <label aria-label="Contacto" class="mb-1">{{'formLabels.contacto' | translate}}</label>
                            <input type="tel" class="form-control" formControlName="phone" placeholder="{{ validatedMember['phone'] }}">
                          </div>

                          <!-- Municipaly Selection -->
                          <div class="form-group col-12 mb-3">
                            <label aria-label="Município" class="mb-1">{{'formLabels.municipio' | translate}}<span class="text-danger ms-1 fw-800">*</span></label>
                            <select aria-label="Selecionar Município" class="form-select" formControlName="municipality" [ngClass]="{ 'is-invalid': submittedReservar && fR['municipality'].errors }">
                              <option value="" selected>{{'formPlaceholders.selecionar' | translate}}</option>
                              <option *ngFor="let municipality of municipalities" value="{{municipality.code}}">{{municipality.name}}</option>
                            </select>
                            <div *ngIf="submittedReservar && fR['municipality'].errors" class="invalid-feedback">{{'formErrorFeedback.preenchimentoObrigatorio' | translate}}</div>
                          </div>

                          <!-- Line Selection -->
                          <div class="form-group col-12 mb-3">
                            <label aria-label="Linha" class="mb-1">{{'formLabels.linha' | translate}}<span class="text-danger ms-1 fw-800">*</span></label>
                            <select aria-label="Selecionar Linha" class="form-select" formControlName="line" [ngClass]="{ 'is-invalid': submittedReservar && fR['line'].errors }">
                              <option value="" selected>{{'formPlaceholders.selecionar' | translate}}</option>
                              <option *ngFor="let line of lines" value="{{line.codeCIM}}">{{line.number}} - {{line.name}}</option>
                            </select>
                            <div *ngIf="submittedReservar && fR['line'].errors" class="invalid-feedback">{{'formErrorFeedback.preenchimentoObrigatorio' | translate}}</div>
                          </div>

                          <!-- Line input -->
                          <div *ngIf="lineOperator != ''" class="col-12 mb-3 d-flex align-items-center">
                            <label aria-label="Operador" class="mb-1">{{'formLabels.operador' | translate}}:&nbsp;</label>
                            <ng-container *ngFor="let logo of lineOperatorLogos; let i = index" >
                              <img
                                [src]="'assets/img/logos/operators/' + logo + '.png'"
                                [alt]="logo"
                                class="p-3 logo-footer"/>
                              <span *ngIf="i < lineOperatorLogos.length -1">/</span>
                            </ng-container>

                          </div>

                          <!-- Unknown Operator -->
                          <div *ngIf="unknownOperator" class="alert alert-warning">
                            <p class="m-0">{{ 'formFeedback.unknownOperator' | translate }}</p>
                          </div>

                          <!-- Stop Selection -->
                          <div class="form-group col-12 mb-3">
                            <label aria-label="Paragem" class="mb-1">{{'formLabels.paragem' | translate}}<span class="text-danger ms-1 fw-800">*</span></label>
                            <select aria-label="Selecionar Paragem" class="form-select" formControlName="stop" [ngClass]="{ 'is-invalid': submittedReservar && fR['stop'].errors }">
                              <option value="" selected>{{'formPlaceholders.selecionar' | translate}}</option>
                              <option *ngFor="let stop of stops" value="{{stop.id}}">{{stop.code}} - {{stop.name}}</option>
                            </select>
                            <div *ngIf="submittedReservar && fR['stop'].errors" class="invalid-feedback">{{'formErrorFeedback.preenchimentoObrigatorio' | translate}}</div>
                          </div>

                          <!-- Date input -->
                          <div class="form-group col-lg-6 col-12 mb-3">
                            <label aria-label="Data" class="mb-1">{{'formLabels.data' | translate}}<span class="text-danger ms-1 fw-800">*</span></label>
                            <input type="text" class="form-control" bsDatepicker [bsValue]="bsValueDay" [bsConfig]="bsConfig" formControlName="date" [ngClass]="{ 'is-invalid': submittedReservar && fR['date'].errors }" >
                            <div *ngIf="submittedReservar && fR['date'].errors" class="invalid-feedback">{{'formErrorFeedback.preenchimentoObrigatorio' | translate}}</div>
                          </div>

                          <!-- Hour Selection -->
                          <div class="form-group col-lg-6 col-12 mb-3">
                            <label aria-label="Horário" class="mb-1">{{'formLabels.horario' | translate}}<span class="text-danger ms-1 fw-800">*</span></label>
                            <select aria-label="Selecionar Horário" class="form-select" formControlName="hour" [ngClass]="{ 'is-invalid': submittedReservar && fR['hour'].errors }">
                              <option value="" selected>{{'formPlaceholders.selecionar' | translate}}</option>
                              <option *ngFor="let hour of hours" value="{{hour.realtimeArrivalDesc}}">{{hour.realtimeArrivalDesc}}</option>
                            </select>
                            <div *ngIf="submittedReservar && fR['hour'].errors" class="invalid-feedback">{{'formErrorFeedback.preenchimentoObrigatorio' | translate}}</div>
                          </div>

                          <!-- Error (working hours) -->
                          <div *ngIf="errorWorkingHours" class="col-12">
                            <div class="alert alert-danger">
                              <!-- <p class="m-0">{{ 'formFeedback.errorReservationWorkingHoursLine1' | translate }}</p> -->
                              <p class="m-0">{{ 'formFeedback.errorReservationWorkingHoursLine2' | translate }}</p>
                              <p class="m-0 fw-800">{{ 'formFeedback.errorReservationWorkingHoursLine3' | translate }}</p>
                            </div>
                          </div>

                         <!-- CheckBox Accept Terms Accessibility -->
                          <div class="form-group col-12 my-2">
                            <div class="form-check">
                              <input type="checkbox" id="acceptTermsAccessibilityReserve" formControlName="acceptTermsAccessibilityReserve" class="form-check-input" [ngClass]="{ 'is-invalid': submittedReservar && fR['acceptTermsAccessibilityReserve'].errors }"/>
                              <label aria-label="Checkbox Termos e Condições Acessibilidade" for="acceptTermsAccessibilityReserve" class="form-check-label fs-12px">{{'formPlaceholders.termosAdesaoReservaText1.1' | translate}} <a [routerLink]="'/direitos-deveres'" target="_blank">{{'formPlaceholders.termosAdesaoReservaText1.2' | translate}}</a>{{'formPlaceholders.termosAdesaoReservaText1.3' | translate}}</label>
                              <div *ngIf="submittedReservar && fR['acceptTermsAccessibilityReserve'].errors" class="invalid-feedback">{{'formErrorFeedback.termosObrigatorio' | translate}}</div>
                            </div>
                          </div>

                          <!-- CheckBox Accept Terms General -->
                          <div class="form-group col-12 my-2">
                            <div class="form-check">
                              <input type="checkbox" id="acceptTermsReserve" formControlName="acceptTermsReserve" class="form-check-input" [ngClass]="{ 'is-invalid': submittedReservar && fR['acceptTermsReserve'].errors }"/>
                              <label aria-label="Checkbox Termos e Condições" for="acceptTermsReserve" class="form-check-label fs-12px">
                                {{'formPlaceholders.termosAdesaoReservaText2.1' | translate}}<a [routerLink]="'/politica-privacidade'" target="_blank" class="fw-700">
                                  {{'navLinks.politicaPrivacidade' | translate}}</a>{{'formPlaceholders.termosAdesaoReservaText2.2' | translate}}
                              </label>
                              <div *ngIf="submittedReservar && fR['acceptTermsReserve'].errors" class="invalid-feedback">{{'formErrorFeedback.termosObrigatorio' | translate}}</div>
                            </div>
                          </div>

                          <!-- Submit button -->
                          <div class="justify-content-end col-12 d-flex form-group my-3">
                            <button type="button" class="btn btn-outline-secondary me-4" title="Voltar" (click)="onBackReservar()">
                              <p class="m-0 fw-600">{{'buttons.voltar' | translate}} <i class="uil uil-left fs-20px ms-2"></i></p>
                            </button>
                            <button type="button" class="btn btn-outline-secondary me-4" title="Limpar Formulário" (click)="onResetReservar()">
                              <p class="m-0 fw-600">{{'buttons.limpar' | translate}} <i class="uil uil-backspace fs-20px ms-2"></i></p>
                            </button>
                            <button [disabled]="errorWorkingHours" type="submit" class="btn btn-primary col-lg-2 col-6" title="Enviar Formulário">
                              <p class="m-0 fw-600">{{'buttons.enviar' | translate}}<i class="uil uil-arrow-up-right fs-20px ms-2 color-white"></i></p>
                            </button>
                          </div>
                        </div>
                      </fieldset>
                    </form>

                    <!-- Loading Message -->
                    <div *ngIf="inProgressReservar" class="row">
                      <div class="col-12">
                        <div class="alert alert-warning">
                          <p class="m-0">{{ 'formFeedback.submittingMember' | translate }}</p>
                          <p class="m-0">{{ 'formFeedback.pleaseWait' | translate }}</p>
                        </div>
                      </div>
                    </div>

                    <!-- Success Info -->
                    <div *ngIf="successReservar" class="row">
                      <div class="col-12">
                        <div class="alert alert-success">
                          <p class="m-0">{{ 'formFeedback.successReservationInfoLine1' | translate }}</p>
                          <p class="m-0">{{ 'formFeedback.successReservationInfoLine2' | translate }}</p>
                          <p class="m-0 fw-800">{{ 'formFeedback.successReservationInfoLine3' | translate }}</p>
                        </div>
                      </div>
                    </div>

                    <!-- Error (general) Info -->
                    <div *ngIf="errorReservar" class="row">
                      <div class="col-12">
                        <div *ngIf="errorReservarServer == ''" class="alert alert-danger">
                          <p class="m-0">{{ 'formFeedback.errorReservationLine1' | translate }}</p>
                          <p class="m-0 fw-800">{{ 'formFeedback.errorReservationLine2' | translate }}</p>
                        </div>
                        <div *ngIf="errorReservarServer != ''" class="alert alert-danger">
                          <p class="m-0 fw-800">{{ errorReservarServer }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </ng-container>
</main>
